import "core-js/modules/es.array.find";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/sdk_manage_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { loadMoreList, commonData, serchSelect } from "@/mixins/index";
import addAppSubmissoin from "./components/addAppSubmissoin.vue";
import parameterPopup from "@/components/parameterPopup/parameterPopup";
export default {
  name: "appSubmission",
  mixins: [loadMoreList, commonData, serchSelect],
  components: {
    addAppSubmissoin: addAppSubmissoin,
    parameterPopup: parameterPopup
  },
  data: function data() {
    return {
      pagingReqFn: "appReviewConfigData",
      // paramsData:{
      // },
      delIds: [],
      tableBody: 'loginTypeConfiguration' // sortReq:'appVersionLoginTypeUpdateSortBy',
      // loginData: ""

    };
  },
  activated: function activated() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.getcommonData(['appListAllData']);

              _this.getcommonData(['appLoginTypeRes']);

              _this.getList();

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: {
    handleSelectionChange: function handleSelectionChange(e) {
      this.delIds = e;
    },
    del: function del(dateList) {
      var _this2 = this;

      var ids = dateList.map(function (item) {
        return item.id;
      }).toString();
      this.$store.dispatch('d2admin/method/deleteList', {
        req: 'appReviewConfigDel',
        data: {
          id: ids
        }
      }).then(function () {
        _this2.getList(_this2.paramsData.page);
      });
    },
    appidChange: function appidChange() {
      this.paramsData.isSearch = false;
    },
    tableRowClassName: function tableRowClassName() {
      if (!this.paramsData.appid || !this.paramsData.isSearch) {
        return 'ignore-sorting';
      }
    },
    payTypeChange: function payTypeChange(e) {
      if (e) {
        var data = this.appLoginTypeRes.find(function (i) {
          return i.id == e;
        });
        this.paramsData.loginTypeId = data.id;
      } else {
        this.paramsData.loginTypeId = '';
      }
    }
  }
};